<template>
  <div id="presentationBody" :style="styleObject" class="currentShowColor bigShadow">
    <lazy-background id="poster" class="centerBackground flexwrap"
                     :src="posterPath"
                     :placeholder='require("../assets/placeholder.png")' :blur="0" :position="isMobile?'top':'center'">

      <div slot="content" id="posterContent">
        <div id="difficulty" class="flexwrap centercenter" :style="{backgroundColor: getBG()} ">
          {{ showDifficulty }}
        </div>
      </div>
    </lazy-background>
    <div id="info" class="plainTheme">
      <div id="infoshow">
        <h2 id="title" class="line-clamp" :class="[isMobile?'clamp2':'clamp2']" :title="selectedShow.english_title.decodeEscapeSequence()">
          {{ selectedShow.english_title.decodeEscapeSequence() }}
        </h2>

        <h3 id="titlefr" class="line-clamp clamp1" style="align-self: flex-end; display: flex;"
            v-if="!isMobile && selectedShow.french_title.decodeEscapeSequence().split('(')[0].trim() != selectedShow.english_title.decodeEscapeSequence()">
          {{ selectedShow.french_title.decodeEscapeSequence().split('(')[0].trim() }}
        </h3>
        <h3 id="year" class="line-clamp clamp1"
            style="align-self: flex-end; display: flex; justify-self: flex-end">
          {{ selectedShow.release_year }}
        </h3>
      </div>
      <div style="width: 100%; display: grid; grid-template-columns: 1fr auto;">
        <div class="attributes-row darkTheme paddingRound mediumRoundAngles">

          <div>
            {{ Math.round(selectedShow.episode_length) +1}}m
          </div>
          <span style="border: #eeeeee 1px solid">{{ getMaturity(selectedShow) }}</span>
        </div>
        <custom-select :options="selectedShow.seasons" :selectedItem="selectedSeasonPosition"
                                   @selected="selectSeason" name="Saison"
                                   :color="selectedShow.color" id="seasonselect" v-if="!isMobile || selectedShow.seasons.length>1"
      ></custom-select>
      </div>

      <div id="showsynopsis">
        {{selectedShow.synopsis.french!=''&&estimated_level<3?selectedShow.synopsis.french:selectedShow.synopsis.sentence}}
      </div>

    <div class="attributes-row darkTheme paddingRound mediumRoundAngles">
      <div class="attributes" :style="{color: wpmColor}">
        <div v-html="wpmIcon"></div>
      </div>{{difficultyAlt.speed}}
    </div>

  <div class="attributes-row darkTheme paddingRound mediumRoundAngles">
    <div class="attributes" :style="{color: dialogueLengthColor}">
      <div v-html="dialogueLengthIcon"></div>
    </div>{{difficultyAlt.knowledge}}
  </div>

    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import CustomSelect from "@/components/customSelect";

export default {
  name: "showPresentation",
  components: {CustomSelect},
  props: {
    selectedSeasonId: Number,
    estimated_level: Number
  },
  created() {
    this.updateData()
  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile',
      'seasonsData',
      'showsData',
    ]),
    posterPath: function (){
      if(this.isMobile){
        return 'https://learnandwatch.s3.eu-west-3.amazonaws.com/' + this.selectedShow.background_path
      }
        return 'https://learnandwatch.s3.eu-west-3.amazonaws.com/' + this.selectedShow.poster_path
    },
    wpmColor: function () {
      //let proportion_over_238wpm = this.currentShow.proportion_over_238wpm
      let proportion_over_260wpm = this.selectedShow.proportion_over_260wpm
      if (proportion_over_260wpm < 73) {
        this.difficultyAlt.speed = "Dialogues très rapides";
        return this.colorsDiffictulty[2]
      } else if (proportion_over_260wpm < 93) {
        this.difficultyAlt.speed = "Quelques dialogues très rapides";
        return this.colorsDiffictulty[1]
      } else {
        this.difficultyAlt.speed = "Dialogues à vitesse correcte";
        return this.colorsDiffictulty[0]
      }
    }
    ,
    wpmIcon: function () {
      let proportion_over_260wpm = this.selectedShow.proportion_over_260wpm
      if (proportion_over_260wpm < 73) {
        return '<i class="fas fa-gauge-max"></i>'
      } else if (proportion_over_260wpm < 93) {
        return '<i class="fas fa-gauge-med"></i>'
      } else {
        return '<i class="fas fa-gauge-min"></i>'
      }

    }
    ,
    dialogueLengthColor: function () {
      let dialogueLength = this.selectedShow.dialogue_length
      if (dialogueLength < 20) {
        this.difficultyAlt.knowledge = "Moins de 20 minutes de dialogues";
        return this.colorsDiffictulty[0]
      } else if (dialogueLength < 40) {
        this.difficultyAlt.knowledge = "Plus de 20 minutes de dialogues";
        return this.colorsDiffictulty[1]
      } else {
        this.difficultyAlt.knowledge = "Plus de 40 minutes de dialogues";
        return this.colorsDiffictulty[2]
      }
    }
    ,
    dialogueLengthIcon: function () {
      return '<i class="fas fa-comments"></i>'
    }
    ,
    showDifficulty: function () {
      let difficulty = this.selectedShow.difficulty_level;
      if (difficulty == 0) {
        return 'A1'
      } else if (difficulty == 1) {
        return 'A2'
      } else if (difficulty == 2) {
        return 'B1'
      } else if (difficulty == 3) {
        return 'B2'
      } else if (difficulty == 4) {
        return 'C1'
      } else {
        return 'C2'
      }
    },
    styleObject: function () {
      if(this.selectedShow.hue != undefined)
      {
        return {
          '--selectedhue': this.selectedShow.hue,
        }
      }
      else {
        return {
          '--selectedhue': 330,
        }
      }

    },
  },
  methods:{
    getBG: function () {
      let difficulty = this.selectedShow.difficulty_level;
      if (difficulty > -1 && difficulty < 5) {
        return this.colorLevel[difficulty]
      } else {
        return "#000000"
      }
    },
    updateData: function(){
      this.selectedSeason = this.seasonsData[this.selectedSeasonId]
      this.selectedShow = this.showsData[this.seasonsData[this.selectedSeasonId].show_id]
      this.selectedShow.seasons.forEach(
          (item, index) => {
            if (item.id === this.selectedSeason.id) {
              this.selectedSeasonPosition = index
            }
          }
      );
    }
    ,
    getMaturity: function (show) {
      if (show.maturityLevel == 35) {
        return 'ALL'
      }
      if (show.maturityLevel == 41) {
        return '7+'
      }
      if (show.maturityLevel == 80) {
        return '13+'
      }
      if (show.maturityLevel == 110) {
        return '16+'
      }
      if (show.maturityLevel == 1000) {
        return '18+'
      }
    }
    ,
    selectSeason: function (index) {
      this.selectedSeasonPosition = index;
      //this.selectedSeasonId = this.selectedShow.seasons[index].id;
      this.$emit('selected', this.selectedShow.seasons[index].id);
    }
  },

  watch:{
    'selectedSeasonId': function() {
      this.updateData();
    },
  },
  data: function () {
    return {
      selectedSeason: {},
      selectedShow: {},
      selectedSeasonPosition: 0,
      difficultyAlt: {
        intensity: "",
        speed: "",
        knowledge: "",
      },
      colorsDiffictulty: ['#55FF8C', '#FFE96E', '#FF5E3D'],
      colorLevel: {
        0: "#56cdac",
        1: "#439f40",
        2: "#f49631",
        3: "#EB3B3B",
        4: "#40407F"
      },
    }
  }
}
</script>

<style scoped>
#presentationBody {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto;
  height: fit-content;
  width: 100%;
  margin: 1vw;
  border-radius: 1.5vw;
  overflow: hidden;
  position: relative;
}
#poster {
  grid-column: 1 / 2;
  grid-row: 1/2;
  z-index: auto;
  overflow: hidden;
}

#posterContent{
  position: relative;
  width: 14vw;
}

#difficulty {
  position: absolute;
  top:0;
  right:0;
  width: 3vw;
  height: 2vw;
  font-weight: bold;
  border-radius: 0 0 0 1vw;
  color: white;
  padding-left: 0.2vw;
  z-index: auto;
  margin-left: 0.75vw;
}


#info {
  height: calc(100% - 2vw);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr auto auto;
  grid-gap: 0.8vw;
  padding: 1vw;
  align-items: flex-start;
}

#infoshow {
  grid-row: 1/2;
  grid-column: 1/2;
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-template-rows: auto auto auto;
  grid-column-gap: 0.5vw;
  height: fit-content;
}

#title {
  grid-column: 1/3;
  grid-row: 1/2;
}
#seasontitle {
  grid-column: 3/4;
  grid-row: 1/2;
  justify-self: flex-end;
  align-self: flex-end;
}

#titlefr {
  grid-column: 1/2;
  grid-row: 2/3;
}

#year {
  grid-column: 2/3;
  grid-row: 2/3;
}

#seasonselect {
  width: fit-content;
  justify-self: flex-end;
  z-index: 20;
}

#showsynopsis{
  text-shadow: 0px 0px 0.7vw var(--darkColor);
  font-style: italic;
  padding: 1vw;
  font-size: 1.15em;
}



.attributes-row {
  display: flex;
  width: fit-content;
  height: fit-content;
  align-items: center;
}

.attributes-row > * {
  margin-right: 0.5vw;
}

.currentShowColor {
  --lightColor: hsla(var(--selectedhue), 100%, 96%, 1);
  --lightplainColor: hsla(var(--selectedhue), 100%, 70%, 1);
  --darkColor: hsla(var(--selectedhue), 100%, 5%, 1);
  --plainColor: hsla(var(--selectedhue), 90%, 25%, 1);
  --lightGrey: hsla(var(--selectedhue), 10%, 80%, 1);
}




@media screen and (max-device-width: 767px) {

  #presentationBody {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 40vw auto;
    min-height: 100%;
    width: 100%;
    margin: 0;
    border-radius: 4vw;
    overflow: hidden;
    position: relative;
  }
  #poster {
    grid-column: 1 / 2;
    grid-row: 1/2;
    z-index: auto;
    overflow: hidden;
  }

  #posterContent{
    position: relative;
    width: 100%;
  }

  #difficulty {
    position: absolute;
    top:0;
    left:0;
    width: 12vw;
    height: 12vw;
    font-weight: bold;
    border-radius: 0 0 5vw 0;
    color: white;
    padding-left: 0;
    margin: 0;
    z-index: auto;
  }


  #info {
    height: calc(100% - 10vw);
    grid-gap: 4vw;
    padding: 5vw;
    align-items: center;
  }

  #infoshow {
    grid-row: 1/2;
    grid-column: 1/2;
    display: grid;
    grid-template-columns: auto auto 1fr;
    grid-template-rows: auto auto auto;
    grid-column-gap: 2.5vw;
    height: fit-content;
  }

  #title {
    grid-column: 1/3;
    grid-row: 1/2;
  }
  #seasontitle {
    grid-column: 3/4;
    grid-row: 1/2;
    justify-self: flex-end;
    align-self: flex-end;
  }

  #titlefr {
    grid-column: 1/2;
    grid-row: 2/3;
  }

  #year {
    grid-column: 2/3;
    grid-row: 2/3;
  }

  #seasonselect {
    width: fit-content;
    justify-self: flex-end;
    z-index: 20;
  }

  #showsynopsis{
    text-shadow: 0px 0px 0.7vw var(--darkColor);
    font-style: italic;
    font-size: 1.15em;
  }
  .attributes-row {
    width: fit-content;
  }

  .attributes-row > * {
    margin-right: 2vw;
  }
}
</style>